module.exports = __webpack_public_path__ + "img/icon-check.a59fb321.svg";